import React from "react";

const Location = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36", isRegular = false}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        {!isRegular ?
            <path
            className="u_fill"
            d="M27.762 24.627L18.333 34l-9.428-9.373a13.232 13.232 0 01-3.649-6.786 13.182 13.182 0 01.759-7.659 13.272 13.272 0 014.91-5.948A13.39 13.39 0 0118.334 2c2.637 0 5.215.777 7.408 2.234a13.272 13.272 0 014.91 5.948 13.183 13.183 0 01.76 7.659 13.232 13.232 0 01-3.65 6.786zm-9.429-3.481c1.572 0 3.08-.62 4.19-1.726a5.874 5.874 0 001.736-4.165c0-1.563-.624-3.061-1.735-4.166a5.944 5.944 0 00-4.19-1.725c-1.572 0-3.08.62-4.19 1.725a5.873 5.873 0 00-1.737 4.166c0 1.562.625 3.06 1.736 4.165a5.944 5.944 0 004.19 1.726zm0-2.946c-.785 0-1.54-.31-2.095-.863a2.937 2.937 0 010-4.165 2.972 2.972 0 014.19 0 2.937 2.937 0 010 4.165 2.972 2.972 0 01-2.095.863z"
            fill={fill}
        />
            :<React.Fragment>
                <path
                stroke={fill || "#4E525F"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3.03}
                d="M13.574 16.118a4.544 4.544 0 1 0 9.089 0 4.544 4.544 0 0 0-9.089 0Z"
                />
                <path
                stroke={fill || "#4E525F"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3.03}
                d="m26.687 24.687-6.427 6.427a3.03 3.03 0 0 1-4.282 0l-6.429-6.427a12.118 12.118 0 1 1 17.138 0Z"
                />
            </React.Fragment>}
    </svg>
);

export default Location;
